import { gsap } from 'gsap';

/*
 * Staggered landing entry, constants from design-spec §7 / plan §10.5.
 * Hero text rises first (0.6 s), cards follow on an overlap (1.2 s, offset -0.7).
 * Under reduced motion the timeline is skipped and everything is shown at rest.
 */
export function playLandingEntry(opts: {
  hero: HTMLElement[];
  cards: HTMLElement[];
  reducedMotion: boolean;
}): gsap.core.Timeline | undefined {
  const { hero, cards, reducedMotion } = opts;

  if (reducedMotion) {
    gsap.set([...hero, ...cards], { clearProps: 'opacity,transform' });
    return undefined;
  }

  const tl = gsap.timeline();
  if (hero.length) {
    tl.fromTo(
      hero,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.6, ease: 'power3.inOut', stagger: 0.14 },
    );
  }
  if (cards.length) {
    tl.fromTo(
      cards,
      { opacity: 0, y: 32 },
      // clearProps drops GSAP's leftover inline transform once the entry settles, so the
      // CSS `.card:hover` lift isn't blocked by an inline `transform: translate(0,0)`.
      { opacity: 1, y: 0, duration: 1.2, ease: 'power3.inOut', stagger: 0.14, clearProps: 'transform' },
      '-=0.7',
    );
  }
  return tl;
}

// Snap hero + cards to their CSS resting state, dropping any inline opacity/transform an
// interrupted or skipped entry run left behind (used in the effect cleanup — see Landing).
export function showLandingAtRest(els: Element[]): void {
  if (els.length) gsap.set(els, { clearProps: 'opacity,transform' });
}
